module.exports = __webpack_public_path__ + "img/cow.87cfa27c.jpeg";